.signet-alert {
  font-family: 'Lato';
  font-weight: 400;
  font-size: 16px;
  padding: 12px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  // margin-bottom: 10px;

  &.success {
    background-color: rgba(102, 187, 106, 0.08);
    // border: 1px solid #409565;
    color: #000000;

    .icon {
      color: #409565;
      margin-right: 5px;
    }
  }

  &.info {
    background-color: rgba(96, 132, 212, 0.15);
    color: #0841bf;

    .icon {
      color: #0841bf;
      margin-right: 10px;
    }
  }

  &.warning {
    background-color: rgba(214, 186, 113, 0.15);
    color: #765e21;

    .icon {
      color: #765e21;
      margin-right: 10px;
    }
  }

  &.error {
    background-color: rgba(232, 126, 124, 0.15);
    color: #000000;

    .icon {
      color: #f25341;
      margin-right: 10px;
    }
  }
}
